import { render, staticRenderFns } from "./date-picker-editor.vue?vue&type=template&id=45b4d096&scoped=true"
import script from "./date-picker-editor.vue?vue&type=script&lang=js"
export * from "./date-picker-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4d096",
  null
  
)

export default component.exports